<template>
    <v-text-field
        :label="$t('sarala-table.labels.search')"
        clearable
        append-icon="mdi-magnify"
        v-model="val"
        @input="val = $event !== null ? $event : undefined"
    ></v-text-field>
</template>

<script>
export default {
    props: ['name', 'resource'],
    data() {
        return {
            val: undefined,
        }
    },

    watch: {
        val(val) {
            const setter = function() {
                if (val === this.val) {
                    this.$store.dispatch('filters/apply', {
                        resource: this.resource,
                        filter: { name: this.name, value: val },
                    })
                }
            }.bind(this)

            setTimeout(setter, 500)
        },

        current(value) {
            if (value === undefined) {
                this.val = value
            }
        },
    },

    computed: {
        key() {
            return [this.resource, this.name].join('.')
        },

        current() {
            return this.$store.getters['filters/getByDotNotation'](this.key)
        },
    },
}
</script>

<style></style>
